// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LeaveRequest  {
    _originalTypeClassName = "Loom.BO.LeaveRequest";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LeaveRequest.translate = translateService;
}
this.Approvals = [];
this.Id = null;
this.StartDate = null;
this.EndDate = null;
this.FinalStatus = null;
this.NumberOfWorkingDays = null;
this.Description = null;
this.EmployeeFullName = null;
this.RequestedOn = null;
this.DayPortion = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
StartDate:any;
EndDate:any;
FinalStatus:any;
NumberOfWorkingDays:any;
Description:any;
EmployeeFullName:any;
RequestedOn:any;
DayPortion:any;
Person:any;
Approvals:any;
LeaveBalance:any;
static setPerson = ($this, value) => {
var oldValue = $this.Person;
$this.Person = value;
if (value != null) {
if (oldValue != null) {
Domain.Person.removeLeaveRequests(oldValue, $this);
}
Domain.Person.addLeaveRequests(value, $this);
}
}
static setApprovals = ($this, items) => {
                if (items == null) items = [];
                if ($this.Approvals == null) $this.Approvals = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Approvals.length > 0) {
                    Domain.LeaveRequest.removeApprovals($this, $this.Approvals[0]);
                }

                Domain.LeaveRequest.addManyApprovals($this, copyItems);
            }
static addManyApprovals = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.LeaveRequest.addApprovals($this, items[i]);
                }
            }
static addApprovals = ($this, item) => {
                if ($this.Approvals == null) $this.Approvals = [];
                if (item == null || $this.Approvals.indexOf(item) > -1) return;
                $this.Approvals.push(item);
if (item.Request != $this) {
Domain.LeaveApproval.setRequest(item, $this);
}
}
static addRangeApprovals = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.LeaveRequest.addApprovals($this, item));
            }
static removeApprovals = ($this, item) => {
                if ($this == null || $this.Approvals == null || $this.Approvals.indexOf(item) === -1) return;
                var _index = $this.Approvals.indexOf(item);
                $this.Approvals.splice(_index, 1);
item.Request = null;
}
static clearApprovals = ($this) => { $this.Approvals = null; }
static setLeaveBalance = ($this, value) => {
var oldValue = $this.LeaveBalance;
$this.LeaveBalance = value;
if (value != null) {
}
}

static CalculateNumberOfWorkingDays($this: any): any{if (($this?.StartDate == null || $this?.EndDate == null || (new Date($this?.StartDate).getTime()) > (new Date($this?.EndDate).getTime()))) {return 0;}
let country = new Domain.Country();
if (($this?.LeaveBalance?.Employee?.Person?.BasedInCountry != null)) {country = $this?.LeaveBalance?.Employee?.Person?.BasedInCountry;}else if (($this?.LeaveBalance?.Policy?.Country != null)) {country = $this?.LeaveBalance?.Policy?.Country;}
if ((country == null)) {return 0;}
if (($this?.DayPortion == Domain.LeaveDayPortion.FirstHalfAM || $this?.DayPortion == Domain.LeaveDayPortion.SecondHalfPM)) {return 0.5;}
return Domain.Country.CalculateBusinessDays(country, new Date(new Date($this?.StartDate)?.setHours(0, 0, 0, 0)), new Date(new Date($this?.EndDate)?.setHours(0, 0, 0, 0)), true);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}